import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faLock, faChevronRight, faCheck, faCheckCircle, faEye, faSquareCheck } from '@fortawesome/free-solid-svg-icons';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { ModalService } from '../../../services/modals/modal.service';

@Component({
  selector: 'app-below-reserve',
  imports: [FontAwesomeModule,
    ButtonModule,
    DialogModule
  ],
  templateUrl: './below-reserve.component.html',
  styleUrl: './below-reserve.component.scss'
})
export class BelowReserveComponent {

  @Input() visible = false;
  @Output() close = new EventEmitter<void>();

  modalService = inject(ModalService);


  faLock = faLock;
  faChevronRight = faChevronRight;
  faCheck = faCheck;
  faCheckCircle = faCheckCircle;
  faEye = faEye;
  faSquareCheck = faSquareCheck

  onClose() {
    // this.close.emit();
    this.modalService.closeModal('has-reserve-item');
  }
}
